const topics = [
  'Fundamentos dos cálculos trabalhistas',
  'Liquidação de sentença na prática',
  'Uso da IA da Exato Cálculos',
  'Embargos e impugnações',
  'Atualização monetária e juros',
  'Casos reais e simulações',
];

export default function Curso() {
  return (
    <section id="curso" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden w-full h-[420px] md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20Brazilian%20lawyer%20or%20legal%20expert%20teaching%20in%20a%20modern%20classroom%20or%20online%20course%20setting%2C%20clean%20white%20background%2C%20professional%20attire%2C%20confident%20posture%2C%20technology%20elements%2C%20bright%20and%20modern%20atmosphere%2C%20high%20quality%20corporate%20photography%20style&width=700&height=500&seq=curso001&orientation=landscape"
                alt="Curso Exato Cálculos"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-white rounded-2xl px-6 py-4 border border-gray-100 w-56"
              style={{ boxShadow: '0 8px 32px rgba(14,165,233,0.15)' }}>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-50">
                  <i className="ri-award-line text-sky-500 text-xl"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Instrutor</div>
                  <div className="text-sm font-bold text-gray-800">Fabiano Garé Costa</div>
                </div>
              </div>
              <div className="text-xs text-gray-500">19 anos de experiência</div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-500 mb-4">Curso Exclusivo</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
              Aprenda cálculos trabalhistas com quem mais entende do assunto
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Ministrado por <strong className="text-gray-700">Fabiano Garé Costa</strong>, perito com 19 anos de experiência e mais de <strong className="text-gray-700">100 mil cálculos realizados</strong>, o curso une ensino prático com acesso direto à IA da Exato Cálculos.
            </p>

            <ul className="space-y-3 mb-8">
              {topics.map((t) => (
                <li key={t} className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-sky-100 shrink-0">
                    <i className="ri-check-line text-sky-600 text-xs"></i>
                  </div>
                  {t}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://danielpawel.github.io/landingpage-fabianogare/" target="_blank"
                //onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-7 py-3.5 rounded-xl text-white font-semibold text-sm cursor-pointer whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 text-center"
                style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
              >
                <span className="inline-flex items-center gap-2">
                  <i className="ri-play-circle-line"></i>
                  Quero acessar o curso
                </span>
              </a>
              <a
                href="#contato"
                onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-7 py-3.5 rounded-xl text-sky-600 font-semibold text-sm cursor-pointer whitespace-nowrap border border-sky-200 hover:bg-sky-50 transition-all duration-200 text-center"
              >
                Saiba mais
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
